import { useOrganizationSettings } from "@hooks/use-organization-settings";

export const useSecureMode = () => {
  const { data: organizationSettings } = useOrganizationSettings();

  return organizationSettings?.secureMode ?? false;
};
